import { Box, Link as MuiLink } from "@mui/material";

import { PolicyLetter } from "api/public/policies/policies.types";
import BulletListCell from "components/MUI/DataGrid/Cells/BulletList.cell";
import LinkCell from "components/MUI/DataGrid/Cells/Link.cell";

const getFileUrl = (filename: string) => `/Policy/${filename}`;

interface PolicyTitleCellProps {
  policy: PolicyLetter;
}

const PolicyTitleCell = ({ policy }: PolicyTitleCellProps) => {
  if (policy.addendums?.length > 0) {
    const addendumLinks = policy.addendums.map((addendum) => ({
      item: (
        <MuiLink
          href={getFileUrl(addendum.filename)}
          target="_blank"
          rel="noreferrer"
        >
          Addendum #{addendum.addendum_num} - {addendum.policy_title}
        </MuiLink>
      ),
      id: addendum.addendum_num,
    }));

    return (
      <Box>
        <LinkCell
          to={getFileUrl(policy.filename)}
          label={policy.policy_title}
          external
        />
        <BulletListCell items={addendumLinks} />
      </Box>
    );
  }

  return (
    <LinkCell
      to={getFileUrl(policy.filename)}
      label={policy.policy_title}
      external
    />
  );
};

export default PolicyTitleCell;
